/**
 *
 * suspend Wire Service Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';

export const SUSPEND_WIRES_URL = (apiUrl, transferId, action) => `${apiUrl}/evaluated_transfers/wire_deposits/${transferId}/${action}`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/suspendWire`;

// Trigger a fetch request in sagas
export const SUSPEND_WIRE_REQUEST = `${NAMESPACE}/SUSPEND_WIRE_REQUEST`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;



// WEBPACK FOOTER //
// ./src/services/suspendWire/constants.js